import { DatePicker, Form, Input, Switch } from "antd";
import React, { useState } from "react";
import UploadImage from "./UploadImage";

interface ModalFormProps {
  modalName: string;
  onFileUpload: Function;
}

function ALCModalForm({ modalName, onFileUpload }: ModalFormProps) {
  const [isActive, setIsActive] = useState(true);

  const handleSwitchToggle = (checked: boolean) => {
    setIsActive(checked);
  };

  return (
    <div className="mb-[20px]">
      <Form.Item label="Profile Picture" rules={[{ required: true }]}>
        <UploadImage onFileUpload={onFileUpload} />
      </Form.Item>
      <div className="grid grid-cols-2 gap-x-6">
        <Form.Item
          name="name"
          label={`${modalName} Name`}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="dob" label="Date of Birth" initialValue="">
          <DatePicker className="w-full" format="YYYY-MM-DD" />
        </Form.Item>
        <Form.Item name="country" label="Country" initialValue="">
          <Input />
        </Form.Item>
        <Form.Item name="email" label="Email">
          <Input />
        </Form.Item>
        <Form.Item name="phoneNumber" label="Phone Number" initialValue="">
          <Input />
        </Form.Item>
      </div>
      <div className="flex gap-[26px] items-center mt-4">
        <div>
          <Form.Item
            valuePropName="checked"
            name="active"
            className="h-4"
            initialValue
          >
            <Switch defaultChecked onChange={handleSwitchToggle} />
          </Form.Item>
        </div>
        <div className="h-5">{isActive ? "Active" : "Inactive"}</div>
      </div>
    </div>
  );
}

export default ALCModalForm;
